export default function(loggedInUserPromise) {
  return SystemJS.import("sofe").then(sofe =>
    sofe.getAllManifests().then(manifest => {
      return SystemJS.import("sentry-error-logging!sofe").then(sentryErrorLogging => {
        if (!loggedInUserPromise) {
          throw new Error(`Cannot initialize sentry without logged in user.`)
        }

        if (!window.splagueisVersion) {
          throw new Error(`Cannot initialize sentry without window.splagueisVersion`)
        }

        sentryErrorLogging.init(`mobile-root-config_${window.splagueisVersion}`, null, null, manifest.flat)

        return loggedInUserPromise.then(loggedInUser => sentryErrorLogging.setUser(loggedInUser))
      })
    }),
  )
}
